import React from "react";
import "./Smart_Finance_Solutions_card.css";
import { Link } from "react-router-dom";

function Smart_Finance_Solutions_card(props) {
    const scrollToSection = (id, offset = 100) => {

        const section = document.getElementById(id);
        if (section) {
            const top = section.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: "smooth" });
        }
    };
  return (
    <>
      <Link onClick={() => scrollToSection("key_feature")}>
        <section className="Smart_Finance_Solutions_card">
          <div className="img_holder">
            <img
              className="finance_img"
              src={process.env.PUBLIC_URL + props?.img}
              alt="finance_img"
            />
          </div>

          <div className="text_holder">
            <p>{props?.loan}</p>
          </div>
        </section>
      </Link>
    </>
  );
}

export default Smart_Finance_Solutions_card;
